// extracted by css-extract-rspack-plugin
module.exports =  {"list":"ActivityChooser-USLl__list","active":"ActivityChooser-lE1E__active"};